import { render, staticRenderFns } from "./RecommendedThreadTeaser.vue?vue&type=template&id=764f8c61&scoped=true&"
import script from "./RecommendedThreadTeaser.vue?vue&type=script&lang=js&"
export * from "./RecommendedThreadTeaser.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedThreadTeaser.vue?vue&type=style&index=0&id=764f8c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f8c61",
  null
  
)

export default component.exports